import { Stack, Text } from 'braid-design-system';

export const SideInfo = () => (
  <Stack space="gutter">
    <Text>
      In order to access our solutions, recruitment software providers must
      satisfy a number of key criteria core to our value proposition to both
      hirers and candidates.
    </Text>
    <Text>
      If you are a recruitment software provider wanting to integrate with SEEK,
      please request access by filling in the below integration request form. We
      will endeavour to confirm the outcome of your request within 10 business
      days.
    </Text>
  </Stack>
);
